<cc-list
    class="filter-value-list"
    [items]="items"
    [enableBlanksSelection]="itemsContainBlanksOption"
    [selectionMode]="'multi'"
    [search]="searchOptions"
    [selectedItems]="selectedItems"
    (selectedItemsChange)="onSelectedChoicesChange($event)"
    (selectBlanks)="selectBlanksChange($event)"
>
    <cc-operator-picker
        [operatorsAvailable]="operatorsAvailable"
        [operatorSelected]="operatorSelected"
        (selectedOperatorChange)="onSelectedOperatorChange($event)"
    >
    </cc-operator-picker>
</cc-list>
